// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"328":"admin","809":"protected"}[chunkId] + "." + {"328":"c94a8a18","809":"bf765773"}[chunkId] + ".css";
};